import { render, staticRenderFns } from "./CompanyEmailRouteManage.vue?vue&type=template&id=aa7a9f72"
import script from "./CompanyEmailRouteManage.vue?vue&type=script&lang=js"
export * from "./CompanyEmailRouteManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa7a9f72')) {
      api.createRecord('aa7a9f72', component.options)
    } else {
      api.reload('aa7a9f72', component.options)
    }
    module.hot.accept("./CompanyEmailRouteManage.vue?vue&type=template&id=aa7a9f72", function () {
      api.rerender('aa7a9f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyEmailRouteManage.vue"
export default component.exports